// Booking status values, ported from the legacy `@micro-apps/shared` constants so this widget doesn't
// have to depend on libs/shared-old.
export const NO_BOOKING = 'NO_BOOKING';
export const PENDING_BOOKING = 'PENDING_BOOKING';
export const PENDING_MOD_BOOKING = 'PENDING_MOD_BOOKING';
export const BOOKED = 'BOOKED';

// Field input types, ported from the legacy `INPUT_TYPES` constant (libs/shared-old) so this widget can
// classify/render a price's dynamic fieldSets without depending on libs/shared-old.
export const INPUT_TYPES = {
	BUTTON_OPTIONS: 'BUTTON_OPTIONS',
	CARD_EXPIRY_DATE: 'CARD_EXPIRY_DATE',
	CARD_NUMBER: 'CARD_NUMBER',
	CHECKBOX: 'CHECKBOX',
	DATE: 'DATE',
	DATE_PICKER: 'DATE_PICKER',
	DROPDOWN: 'DROPDOWN',
	EMAIL: 'EMAIL',
	NUMBER: 'NUMBER',
	PHONE: 'PHONE',
	RADIO: 'RADIO',
	TEXT: 'TEXT',
	TEXTAREA: 'TEXTAREA',
	TIME: 'TIME',
	HIDDEN: 'HIDDEN',
} as const;

export type InputTypeValue = (typeof INPUT_TYPES)[keyof typeof INPUT_TYPES];

export const DEFAULT_ITINERARY_DISCLAIMER =
	'Our concierge team will craft the best itinerary for you based on your request. Please note that your request is not confirmed until a concierge contacts you directly to finalize the details. Charges will only be applied once your request is confirmed.';

/** Matches the legacy `[data-booking-widget]` selector `BookingWidgetPreview` scrolls to / observes. */
export const BOOKING_WIDGET_SELECTOR_ATTR = 'data-booking-widget';

/** The inline step this widget is showing in place of what used to be `AddToCartFormModal`'s steps. */
export const BOOKING_FLOW_STEP = {
	FORM: 'form',
	CONFIRMATION: 'confirmation',
	SUCCESS: 'success',
} as const;

export type BookingFlowStep = (typeof BOOKING_FLOW_STEP)[keyof typeof BOOKING_FLOW_STEP];

export const BOOKING_FORM_ID = 'product-booking-widget-booking-form';
